import React, { useEffect, useRef } from "react";
import L from "leaflet";
import "leaflet/dist/leaflet.css";

const icon = new L.Icon({
  iconUrl: "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4/images/marker-icon.png",
  iconRetinaUrl: "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4/images/marker-icon-2x.png",
  shadowUrl: "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4/images/marker-shadow.png",
  iconSize: [25, 41], iconAnchor: [12, 41], popupAnchor: [1, -34], shadowSize: [41, 41],
});

export const ClinicMap = ({ clinics = [], userPos, onSelect, className = "" }) => {
  const elRef = useRef(null);
  const mapRef = useRef(null);
  const layerRef = useRef(null);

  useEffect(() => {
    if (!elRef.current || mapRef.current) return;
    mapRef.current = L.map(elRef.current, { scrollWheelZoom: false }).setView([20, 0], 2);
    L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
      attribution: "&copy; OpenStreetMap", maxZoom: 19,
    }).addTo(mapRef.current);
    layerRef.current = L.layerGroup().addTo(mapRef.current);
    return () => { if (mapRef.current) { mapRef.current.remove(); mapRef.current = null; } };
  }, []);

  useEffect(() => {
    const map = mapRef.current, layer = layerRef.current;
    if (!map || !layer) return;
    layer.clearLayers();
    const pts = [];
    clinics.forEach((c) => {
      if (c.lat == null || c.lng == null) return;
      const m = L.marker([c.lat, c.lng], { icon }).addTo(layer);
      m.bindPopup(`<strong>${c.name}</strong><br/>${c.location}`);
      if (onSelect) m.on("click", () => onSelect(c.slug));
      pts.push([c.lat, c.lng]);
    });
    if (userPos) {
      L.circleMarker([userPos.lat, userPos.lng], { radius: 8, color: "#B89C72", fillColor: "#B89C72", fillOpacity: 1, weight: 3 })
        .addTo(layer).bindPopup("You are here");
      pts.push([userPos.lat, userPos.lng]);
    }
    if (pts.length) {
      try { map.fitBounds(pts, { padding: [40, 40], maxZoom: 11 }); } catch (e) { /* ignore */ }
      setTimeout(() => map.invalidateSize(), 200);
    }
  }, [clinics, userPos, onSelect]);

  return <div ref={elRef} data-testid="clinic-map" className={`w-full h-72 rounded-3xl overflow-hidden border border-brand-border/60 ${className}`} style={{ zIndex: 0 }} />;
};
